/** 
* 自动生成文件，请勿修改 
* @name: 资产:设备类别模块
* @description: 设备类别-增删改查
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:7条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const deviceCategory = { 
	/** 1 summary:保存/修改-单条	method:post */ 
	saveOrUpd : new APIObject("/api/deviceCategory/saveOrUpd.do"), 
	/** 2 summary:删除-单条	method:post */ 
	delete : new APIObject("/api/deviceCategory/delete.do"), 
	/** 3 summary:保存/修改-批量	method:post */ 
	batchSaveOrUpd : new APIObject("/api/deviceCategory/batchSaveOrUpd.do"), 
	/** 4 summary:查询-单条数据	method:post */ 
	queryOne : new APIObject("/api/deviceCategory/queryOne.do"), 
	/** 5 summary:删除-批量	method:post */ 
	batchDelete : new APIObject("/api/deviceCategory/batchDelete.do"), 
	/** 6 summary:查询-根据一个大类id查询其下的所有小类	method:post */ 
	findSmallCategory : new APIObject("/api/deviceCategory/findSmallCategory.do"), 
	/** 7 summary:查询-大类小类树形结构	method:post */ 
	queryOneLevel : new APIObject("/api/deviceCategory/queryOneLevel.do"), 
};
export default deviceCategory;